import { Text, View } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import { AuditTrailGroupItemType } from '../../../../types/AuditTrail'
import { AuditTrailColumnStyles } from '../styles/AuditTrailColumnStyles'

interface AuditTrailTableHeaderProps {
  type: AuditTrailGroupItemType
}

export const AuditTrailTableHeader = ({ type }: AuditTrailTableHeaderProps) => {
  const { t } = useTranslation()
  const { cellTransaction, cellDate, cellVoucher, cellDescription } = AuditTrailColumnStyles
  const { row, headerRow, headerText, cell, cellRight } = commonPdfTableStyles

  return (
    <View style={[row, headerRow]} wrap={false}>
      <View style={cellTransaction}>
        <Text style={headerText}>#</Text>
      </View>
      <View style={cellDate}>
        <Text style={headerText}>{t('audit_trail.table.header.date')}</Text>
      </View>
      <View style={cellVoucher}>
        <Text style={headerText}>{t('audit_trail.table.header.voucher')}</Text>
      </View>
      <View style={[cell, cellDescription]}>
        <Text style={headerText}>{t('audit_trail.table.header.description')}</Text>
      </View>
      {type === 'account' && (
        <View style={[cell, cellRight]}>
          <Text style={headerText}>{t('audit_trail.table.header.net')}</Text>
        </View>
      )}
      {type === 'account' && (
        <View style={[cell, cellRight]}>
          <Text style={headerText}>{t('audit_trail.table.header.rate')}</Text>
        </View>
      )}
      <View style={[cell, cellRight]}>
        <Text style={headerText}>{t('audit_trail.table.header.amount')}</Text>
      </View>
      <View style={[cell, cellRight]}>
        <Text style={headerText}>{t('audit_trail.table.header.balance')}</Text>
      </View>
    </View>
  )
}
